const BalanceCardSmallIcon = () => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9165 5.49333V2.83333C21.9165 1.55 20.8665 0.5 19.5832 0.5H3.24984C1.95484 0.5 0.916504 1.55 0.916504 2.83333V19.1667C0.916504 20.45 1.95484 21.5 3.24984 21.5H19.5832C20.8665 21.5 21.9165 20.45 21.9165 19.1667V16.5067C22.6048 16.0983 23.0832 15.3633 23.0832 14.5V7.5C23.0832 6.63667 22.6048 5.90167 21.9165 5.49333ZM20.7498 7.5V14.5H12.5832V7.5H20.7498ZM3.24984 19.1667V2.83333H19.5832V5.16667H12.5832C11.2998 5.16667 10.2498 6.21667 10.2498 7.5V14.5C10.2498 15.7833 11.2998 16.8333 12.5832 16.8333H19.5832V19.1667H3.24984Z"
        fill="#975100"
      />
      <path
        d="M16.0832 12.75C17.0497 12.75 17.8332 11.9665 17.8332 11C17.8332 10.0335 17.0497 9.25 16.0832 9.25C15.1167 9.25 14.3332 10.0335 14.3332 11C14.3332 11.9665 15.1167 12.75 16.0832 12.75Z"
        fill="#975100"
      />
    </svg>
  );
};

export default BalanceCardSmallIcon;
